
define('text!TescoMobile_Checkout/template/subscription-details/message-content.html',[],function () { return '<div class="subscription-details-message" data-bind="html: messageContent"></div>';});

